module.exports = __webpack_public_path__ + "img/dswm-2-sm.7bf678ef.jpg";